import { render, staticRenderFns } from "./slide-library-search.vue?vue&type=template&id=522ade89&scoped=true&"
import script from "./slide-library-search.vue?vue&type=script&lang=js&"
export * from "./slide-library-search.vue?vue&type=script&lang=js&"
import style0 from "./slide-library-search.vue?vue&type=style&index=0&id=522ade89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ade89",
  null
  
)

export default component.exports